import {z} from '@hono/zod-openapi';

import {optionItemSchema} from '../common/OptionItemSchema';

export const extractDeliveryNoteDocumentMessageInputSchema = z
  .object({
    fileId: z.string().optional(),
    zipId: z.string().optional(),
    fileName: z.string(),
    sourceFormat: z.literal('NISSAN_DIGLAS').optional(),
    suppliers: z.array(optionItemSchema),
    units: z.array(optionItemSchema),
    vat: z.array(optionItemSchema),
  })
  .refine((data) => data.fileId || data.zipId, {
    message: 'Either fileId or zipId must be provided',
  })
  .refine((data) => !data.sourceFormat || (Boolean(data.fileId) && !data.zipId), {
    message: 'Structured invoice imports require a single original file, not an image archive',
  });

export type ExtractDeliveryNoteDocumentMessageInput = z.infer<
  typeof extractDeliveryNoteDocumentMessageInputSchema
>;

export type ExtractDeliveryNoteDocumentUseCaseInput = ExtractDeliveryNoteDocumentMessageInput & {
  tenantId: string;
  requestId: string;
  userId?: string;
  workspace?: string;
};
